import React, { useEffect, useState, useContext } from "react";
import UserCard from "../components/documents-reports/UserCards";
import { AuthContext } from "../context/Auth/AuthContext";
/*** Main component for listing the details of document requests (count of uploaded documents for requests) for Users ***/
const UsersDocumentsReports = () => {
  const { is_admin, token, firstName, lastName, id } = useContext(AuthContext);
  // BOXSHADOW
  const customBoxShadow = {
    boxShadow: "0px 1px 3px #1a6b7c",
  };

  return (
    <>
      <div className=" flex-col md:flex w-full  overflow-y-scroll">
        <div className="flex-1 space-y-4 p-8 pt-6 w-full">
          <UserCard
            customBoxShadow={customBoxShadow}
            token={token}
            is_admin={is_admin}
            userId={id}
          />
        </div>
      </div>
    </>
  );
};
export default UsersDocumentsReports;
